module.exports = __webpack_public_path__ + "static/caddy-style-56cc725383c5fec348777fd9ec742905.png";